import {TranslateService} from '@ngx-translate/core';
import {ImportModulePreflightRow} from '../../core/definitions/import-module';

/** The target label key for each `created_revision` kind, in the order a
 * row preview lists them. */
export const CREATED_REVISION_KIND_LABELS: Record<string, string> = {
  created_at: 'TRANS__IMPORT__TARGET__CREATED_AT',
  created_by: 'TRANS__IMPORT__TARGET__CREATED_BY',
};

/** The translated target label for a `created_revision` kind
 * (`created_at` / `created_by`); the kind itself for one with no label. */
export function createdRevisionKindLabel(kind: string, translate: TranslateService): string {
  const key = CREATED_REVISION_KIND_LABELS[kind];
  return key ? translate.instant(key) : kind;
}

/** A preflight row's `created_revision` parts as `[kind, part]` pairs, in
 * the order of `CREATED_REVISION_KIND_LABELS`. */
export function createdRevisionParts(row: ImportModulePreflightRow): [string, { value: string; status: string }][] {
  const parts = row.created_revision;
  if (!parts) {
    return [];
  }
  return Object.keys(CREATED_REVISION_KIND_LABELS)
    .filter(kind => parts[kind])
    .map(kind => [kind, parts[kind]]);
}
